export const PAGE_SIZE = 20
export const QUANTITY_DISPLAY_MAX_DECIMAL_PLACES = 2
export const QUANTITY_INPUT_MAX_DECIMAL_PLACES = 3

export const AUTO_HIDE_DURATION = 5000

export const INSTRUMENTS_COUNT = 9
